import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IDrugDetail } from 'src/app/pages/settings/drug-tab/drug-list/idrug';
import { HospitalAddOnService } from 'src/app/services/hospital-add-on.service';

@Component({
  selector: 'app-pharmacy-availability',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule, TablerIconsModule],
  host: { '[class.lookup-notice]': 'showLookupNotice' },
  template: `
    <ng-container *ngIf="messageKey as message">
      <small *ngIf="showLookupNotice; else medicineIcon" class="availability-warning" role="status">{{ message | translate }}</small>
      <ng-template #medicineIcon>
        <button type="button" class="medicine-warning" [matTooltip]="message | translate"
          matTooltipPosition="above" [attr.aria-label]="message | translate">
          <i-tabler name="info-circle" class="icon-18" aria-hidden="true"></i-tabler>
        </button>
      </ng-template>
    </ng-container>`,
  styles: [`:host { display: inline-flex; vertical-align: middle; }
    :host.lookup-notice { display: block; }
    .availability-warning { display: block; color: #8a4b08; margin: 4px 0 8px; }
    .medicine-warning { display: inline-flex; align-items: center; justify-content: center;
      color: var(--mat-sys-error, #d32f2f); background: transparent; border: 0;
      width: 32px; height: 32px; padding: 6px; cursor: help; }
    .medicine-warning:focus-visible { outline: 2px solid currentColor; border-radius: 50%; }
    @media print { :host { display: none !important; } }`],
})
export class PharmacyAvailabilityComponent {
  @Input() drugId: number | null = null;
  @Input() drugs: IDrugDetail[] = [];
  @Input() lookupFailed = false;
  @Input() showLookupNotice = false;

  constructor(private addOns: HospitalAddOnService) {}

  get messageKey(): string {
    if (!this.addOns.isPharmacyEnabled) {
      return '';
    }
    if (this.showLookupNotice) {
      return this.lookupNotice;
    }
    const status = this.drugs.find(drug => drug.id === this.drugId)?.pharmacyAvailability;
    if (status === 'notStocked') {
      return 'PHARMACY.MEDICINE_NOT_STOCKED';
    }
    return status === 'outOfStock' ? 'PHARMACY.MEDICINE_OUT_OF_STOCK' : '';
  }

  private get lookupNotice(): string {
    const unchecked = this.drugs.some(drug => drug.pharmacyAvailability == null);
    return this.lookupFailed || unchecked ? 'PHARMACY.AVAILABILITY_CHECK_FAILED' : '';
  }
}
